var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.contact
      ? _c("div", [
          !!_vm.email
            ? _c(
                "p",
                { staticStyle: { "font-size": "16px", "margin-bottom": "0" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("email_label")) +
                      " " +
                      _vm._s(_vm.email) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !!_vm.telephone
            ? _c(
                "p",
                { staticStyle: { "font-size": "16px", "margin-bottom": "0" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("telephone_label")) +
                      " " +
                      _vm._s(_vm.telephone) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !!_vm.href_website
            ? _c("a", { attrs: { href: _vm.href_website, target: "_blank" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("website_label")) +
                    " " +
                    _vm._s(_vm.website) +
                    "\n    "
                )
              ])
            : !!_vm.website
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("website_label")) + " " + _vm._s(_vm.website)
                )
              ])
            : _vm._e()
        ])
      : _c("p", [_vm._v("-")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf6573c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf6573c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = null
// module chunks = 